<template>
    <div class="mb-24">
        <div class="grid grid-cols-2 gap-16">
            <div class="col-span-2">
                <simple-input
                    :disabled="disabled"
                    :input-label="$t('multi-posting.campaigns.form.contract_alias')"
                    :value="form.contractAlias"
                    @input="(value) => formChanged('contractAlias', value)"
                />
            </div>
            <div class="col-span-1">
                <date-picker
                    :disabled="disabled"
                    disablePast
                    disableToday
                    :input-label="$t('general.expiry_date')"
                    :value="form.contractExpiry"
                    @input="(value) => formChanged('contractExpiry', value)"
                />
            </div>
            <div class="col-span-1">
                <simple-input
                    type="number"
                    :disabled="disabled"
                    :input-label="$t('general.purchase_price') + (pricingMandatory ? '*' : '')"
                    :value="form.purchasePrice"
                    @input="(value) => formChanged('purchasePrice', value)"
                />
            </div>
            <div class="col-span-1">
                <simple-input
                    type="number"
                    :disabled="disabled"
                    :input-label="$t('general.credits')"
                    :value="form.credits"
                    @input="(value) => formChanged('credits', value)"
                />
            </div>
            <div class="col-span-1">
                <select-dropdown
                    :auto-translate="false"
                    :disabled="disabled"
                    :input-label="$t('general.currency') + (pricingMandatory ? '*' : '')"
                    :options="currencies"
                    :value="form.currency"
                    @change="(value) => formChanged('currency', value)"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Form from "../../etc/forms/Form";
import SimpleInput from "../forms/Input.vue";
import SimpleButton from "../ui/SimpleButton.vue";
import Checkbox from "../forms/Checkbox.vue";
import SelectDropdown from "../forms/SelectDropdown.vue";
import DatePicker from "../forms/DatePicker.vue";

export default {
    name: 'MultiPostingOptionalContractForm',
    components: { SelectDropdown, Checkbox, SimpleButton, SimpleInput, DatePicker },
    data() {
        return {
            approved: false,
        }
    },
    props: {
        form: Form,
        contractCredentials: Array,
        disabled: Boolean,
    },
    computed: {
        currencies() {
            return [
                { value: 'EUR', label: 'EUR' },
                { value: 'USD', label: 'USD' },
                { value: 'GBP', label: 'GBP' },
                { value: 'AUD', label: 'AUD' },
            ];
        },
        pricingMandatory() {
            return !!this.form.purchasePrice || !!this.form.currency;
        }
    },
    methods: {
        validateCredits(value) {
            const defaultCredits = 0;
            return (value != null && value < defaultCredits) ? defaultCredits : value;
        },
        validatePrice(value) {
            const defaultPurchasePrice = 1;
            return ((value != null || String(value) === "0") && value < defaultPurchasePrice) ? defaultPurchasePrice : value;
        },
        formChanged(field, value) {
            if (field === 'credits') {
                this.$emit('formChanged', {field: field, val: this.validateCredits(value)});
            } else if (field === 'purchasePrice') {
                this.$emit('formChanged', {field: field, val: this.validatePrice(value)});
            } else {
                this.$emit('formChanged', {field: field, val: value});
            }
        }
    }
}
</script>
